import { useEffect, useState } from '@redneckz/uni-jsx/lib/hooks';
import { useAsyncData } from '@redneckz/uni-jsx/lib/hooks/useAsyncData';
import { useDebouncedEffect } from '@redneckz/uni-jsx/lib/hooks/useDebouncedEffect';
import { fetchJSON } from '../../utils/fetchJSON.js';
import { joinPath } from '../../utils/url.js';
import { search } from './search.js';
const SEARCH_INDEX_FILENAME = 'search.index.json';
export const useSearch = ({ basePathList, initialQuery = '', }) => {
    const [query, setQuery] = useState(initialQuery || '');
    useEffect(() => {
        if (initialQuery !== undefined && initialQuery !== null) {
            setQuery(initialQuery);
        }
    }, [initialQuery]);
    const { data } = useAsyncData(basePathList?.length ? basePathList : null, fetchSearchIndex);
    const [result, setResult] = useState(null);
    useDebouncedEffect(() => {
        if (data) {
            setResult(data.map(search(query)));
        }
    }, [data, query]);
    return [result, { value: query, onChange: setQuery }];
};
const fetchSearchIndex = async (...basePathList) => (await Promise.allSettled(basePathList.map((basePath) => fetchJSON(joinPath(basePath, '/', SEARCH_INDEX_FILENAME))))).map((_) => (_.status === 'fulfilled' ? _.value : {}));
//# sourceMappingURL=useSearch.js.map